import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/fornecedores/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findFornecedores(
  empresa_cnpj,
  id,
  per_page = 1000,
  include = ""
) {
  return search(
    `${path}${id ? `/${id}` : ""}?empresa_cnpj=${empresa_cnpj}${
      per_page && `&per_page=${per_page}${include && `&include=${include}`}`
    }`,
    "GET",
    headers
  );
}

export async function findFornecedorByCpfCnpj(empresa_cnpj, cpfcnpj) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[cgc]=${cpfcnpj}`,
    "GET",
    headers
  );
}
